var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryVolts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 6.999986286719387 12.99999",
    width: 6.999986286719387,
    height: 12.99999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.0000029425224274074596, -0.000010000000000648379) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "url(&quot"
    },
    d: "M2.56645,13v0c-0.2428,0 -0.43536,-0.22503 -0.40187,-0.47603l0.62792,-4.57856h-2.4447c-0.61117,0 -0.23442,-0.54527 -0.21768,-0.56258c0.87909,-1.60985 2.2019,-3.99001 3.9517,-7.1751c0.06698,-0.12983 0.20931,-0.20772 0.35163,-0.20772v0c0.2428,0 0.43536,0.22503 0.40187,0.47603l-0.62792,4.57856h2.45307c0.27628,0 0.43536,0.13848 0.27628,0.47603c-2.30237,4.14581 -3.63356,6.56924 -4.01868,7.26165c-0.06698,0.12983 -0.20093,0.20772 -0.35163,0.20772z",
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1685459482725611",
    d: "M2.56645,13v0c-0.2428,0 -0.43536,-0.22503 -0.40187,-0.47603l0.62792,-4.57856h-2.4447c-0.61117,0 -0.23442,-0.54527 -0.21768,-0.56258c0.87909,-1.60985 2.2019,-3.99001 3.9517,-7.1751c0.06698,-0.12983 0.20931,-0.20772 0.35163,-0.20772v0c0.2428,0 0.43536,0.22503 0.40187,0.47603l-0.62792,4.57856h2.45307c0.27628,0 0.43536,0.13848 0.27628,0.47603c-2.30237,4.14581 -3.63356,6.56924 -4.01868,7.26165c-0.06698,0.12983 -0.20093,0.20772 -0.35163,0.20772z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-168545948452227512",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "36%",
    stopColor: "rgb(237,139,0)",
    stopOpacity: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(238,76,20)",
    stopOpacity: 1,
    vectorEffect: "non-scaling-stroke"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryVolts);
export default __webpack_public_path__ + "static/media/battery-volts.591c327dc34258ef0947d1b09de5afbe.svg";
export { ForwardRef as ReactComponent };